import React, { useContext, useEffect, useState } from "react";
import { Alert, Box, Button, Checkbox, FormControlLabel, Grid, IconButton, MenuItem, Snackbar, Stack, TextField, Typography } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TextInput from "../components/textInput";
import updateUserData from "../misc/userProvider";
import { UserContext } from "../theme/userContext";
import { useNavigate } from "react-router-dom";

const Settings = () => {

    const { user, onLogout } = useContext(UserContext);
    const [tableDensity, setTableDensity] = useState('compact');
    const [mode, setMode] = useState('dark');
    const [notifications, setNotifications] = useState(false);
    const [mcpToken, setMcpToken] = useState('');
    const [mcpSnackbar, setMcpSnackbar] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (user && user.settings) {
            setTableDensity(user.settings.tableDensity);
            setMode(user.settings.mode);
            setNotifications(user.settings.notifications || false);
        }
        // eslint-disable-next-line
    }, [user]);

    // Close view
    const handleClose = () => {
        navigate(-1);
    };

    const handleSave = async () => {

        console.log("Settings handleSave()... ");
        const userData = { ...user, settings: { ...user.settings, "tableDensity": tableDensity, "mode": mode, "notifications": notifications } };
        updateUserData(userData);

        await onLogout();
        navigate('/login');
    };

    return (
        <Box id="portTableMainBox" m="20px" >
            <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                <Grid item xs={4}>
                    <Typography variant="h2">Settings</Typography>
                </Grid>
                <Grid item xs={8}>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h5">{user.email}</Typography>
                </Grid>
                <Grid item xs={8}>
                </Grid>
                <Grid item xs={4} mt={4}>
                    <TextInput
                        id="typeMode"
                        value={mode}
                        label='Mode (Dark/Light)'
                        name="selModeType"
                        fullWidth
                        select
                        onChange={(e) => setMode(e.target.value)}
                    >
                        <MenuItem value="dark">Dark</MenuItem>
                        <MenuItem value="light">Light</MenuItem>
                    </TextInput>
                    <Grid item xs={4} minHeight={12}>

                    </Grid>
                    <TextInput
                        id="typeSelect"
                        value={tableDensity}
                        label='Tabellengröße'
                        name="selDensityType"
                        fullWidth
                        select
                        onChange={(e) => setTableDensity(e.target.value)}
                    >
                        <MenuItem value="compact">Compact</MenuItem>
                        <MenuItem value="standard">Standard</MenuItem>
                        <MenuItem value="comfortable">Comfortable</MenuItem>
                    </TextInput>

                </Grid>
                <Grid item xs={8}>

                </Grid>

                <Grid item xs={4}>
                    <Stack>
                        <FormControlLabel control={<Checkbox
                            checked={notifications}
                            onChange={(e) => setNotifications(e.target.checked)}
                            inputProps={{ 'aria-label': 'notifications checkbox' }}
                        />} label="Mail Benachrichtigungen" />
                        <Typography variant="h7">Tägliche Mail mit Angaben zu Dividendenzahlungen und Insiderkäufen.</Typography>
                    </Stack>
                </Grid>

                <Grid item xs={8}>

                </Grid>

                <Grid item xs={4} mt={4}>
                    <Stack direction="row" alignItems="center" justifyContent='space-between'>
                        <Button variant="outlined" onClick={handleClose}>Abbrechen</Button>
                        <Typography mr={1} ml={1} variant="h7" textAlign="right">Nach dem Speichern werden Sie automatisch abgemeldet.</Typography>
                        <Button ml={2} variant="contained" onClick={handleSave} color="success">Speichern</Button>
                    </Stack>
                </Grid>
                <Grid item xs={8}>
                </Grid>

                <Grid item xs={12} mt={6}>
                    <Typography variant="h4">MCP Server (Claude AI)</Typography>
                    <Typography variant="body2" mt={1}>
                        Verbinde deinen Finalyser-Account mit Claude Desktop oder Claude Code, um dein Portfolio und Marktdaten per KI abzufragen.
                    </Typography>
                </Grid>

                <Grid item xs={4} mt={2}>
                    <Button variant="contained" onClick={async () => {
                        try {
                            const url = process.env.REACT_APP_API_URI + "/api/auth/mcp-token";
                            const response = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" } });
                            if (!response.ok) throw new Error("Token-Generierung fehlgeschlagen");
                            const data = await response.json();
                            setMcpToken(data.token);
                        } catch (error) {
                            console.error(error);
                        }
                    }}>
                        MCP Token generieren
                    </Button>
                </Grid>
                <Grid item xs={8}></Grid>

                {mcpToken && (
                    <>
                        <Grid item xs={6} mt={2}>
                            <Typography variant="h6" mb={1}>Claude Desktop / Claude Code Config</Typography>
                            <Typography variant="body2" mb={1}>
                                Kopiere diese Konfiguration in deine Claude Desktop Einstellungen unter Settings &gt; Developer &gt; Edit Config:
                            </Typography>
                            <Box sx={{ position: 'relative' }}>
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={12}
                                    value={JSON.stringify({
                                        mcpServers: {
                                            finalyser: {
                                                url: (process.env.REACT_APP_API_URI || "https://finalyser.app") + "/mcp",
                                                headers: {
                                                    Authorization: "Bearer " + mcpToken
                                                }
                                            }
                                        }
                                    }, null, 2)}
                                    InputProps={{ readOnly: true, sx: { fontFamily: 'monospace', fontSize: '0.8rem' } }}
                                />
                                <IconButton
                                    sx={{ position: 'absolute', top: 8, right: 8 }}
                                    onClick={() => {
                                        navigator.clipboard.writeText(JSON.stringify({
                                            mcpServers: {
                                                finalyser: {
                                                    url: (process.env.REACT_APP_API_URI || "https://finalyser.app") + "/mcp",
                                                    headers: {
                                                        Authorization: "Bearer " + mcpToken
                                                    }
                                                }
                                            }
                                        }, null, 2));
                                        setMcpSnackbar(true);
                                    }}
                                >
                                    <ContentCopyIcon />
                                </IconButton>
                            </Box>
                            <Typography variant="body2" mt={1} color="text.secondary">
                                Token gültig bis: {new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toLocaleDateString('de-DE')}
                            </Typography>
                        </Grid>
                        <Grid item xs={6}></Grid>
                    </>
                )}

                <Snackbar open={mcpSnackbar} autoHideDuration={2000} onClose={() => setMcpSnackbar(false)}>
                    <Alert severity="success" onClose={() => setMcpSnackbar(false)}>Konfiguration kopiert!</Alert>
                </Snackbar>

            </Grid>
        </Box>
    )
}

export default Settings
